import React from "react";
import './TableSection.scss'
import { RowColors, RowOptions } from "../../data/tableTypes";

export { RowColors } from "../../data/tableTypes";
export type { RowOptions } from "../../data/tableTypes";



interface TableSectionProps {
    blurb?: string
    header: string[]
    rows: RowOptions[]
    
}

export class TableSection extends React.Component<TableSectionProps> {

    constructor(props: any) {
        super(props);
    }

    renderTable () {
        let regRows: JSX.Element[] = []

        for(let i=0; i< this.props.rows.length; i++){
            regRows.push(this.renderRow(this.props.rows[i]))
        }
        

        return(
            <div className = 'table-container'>
                <div className='table-border'>
                    <table className="table-body">
                        <tbody>
                        {this.renderRow()}
                        {regRows}
                        </tbody>

                    </table>
                </div>
            </div>

        )
   
    }

    renderRow(cells?: RowOptions) {
        let row: JSX.Element[] = [];
        var header: boolean = false;

        if (cells){
            for (let i = 0; i < cells.cellNames.length; i++) { //rendering the normal rows
                const data = cells.cellNametoLinks.get(cells.cellNames[i]) ? <td key={i} className="table-cell"> <a href={`${cells.cellNametoLinks.get(cells.cellNames[i])}`} rel="noopener noreferrer" target="_blank"> {cells.cellNames[i]} </a></td> : <td key={i} className="table-cell"> {cells.cellNames[i]}</td>
                row.push(data);
            }
        } else {
            header = true;
            for (let i=0; i < this.props.header.length; i++){ //rendering the headers 
                row.push(<th key={i}className="table-cell header"> {this.props.header[i]}</th>)             
            }

        }

        console.log(cells?.backgroundColor)

        return (
            <tr className={`row ${header ? 'header' : ''}`} style={{'backgroundColor': cells?.backgroundColor ?? RowColors.RELEASED}}>
                {row}
            </tr>
        );
    }
    

   render() {
    return(
        <div className = "lab-text">
            {this.props.blurb ? <div className="description">
                <p> {this.props.blurb}</p>
            </div> : ""}
            {this.renderTable()}
        </div>
    )
   }



}
